(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.fpcAjaxQuickAddInitializedV2) return;
    window.fpcAjaxQuickAddInitializedV2 = true;

    const PRODUCT_CARD_ADDED_EVENT = 'sv:product-card-added';

    const setStatus = (button, message) => {
      const wrapper = button.closest('[data-fashion-quick-action]');
      const status = wrapper?.querySelector('.fpc-quick-action__status');
      if (status) status.textContent = message;
    };

    const getShopRoot = () => {
      const root = window.Shopify?.routes?.root || '/';
      return root.endsWith('/') ? root : `${root}/`;
    };

    const parseJsonResponse = async (response) => {
      let data = null;

      try {
        data = await response.json();
      } catch (_) {}

      if (!response.ok || data?.status) {
        throw new Error(
          data?.description ||
          data?.message ||
          'Unable to add this item to the cart.'
        );
      }

      return data;
    };

    const addWithAjax = async (variantId) => {
      const formData = new FormData();
      formData.set('id', String(variantId));
      formData.set('quantity', '1');

      const response = await fetch(`${getShopRoot()}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      });

      return parseJsonResponse(response);
    };

    const getCart = async () => {
      const response = await fetch(`${getShopRoot()}cart.js`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      return parseJsonResponse(response);
    };

    document.addEventListener('click', async (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const button = target?.closest('[data-fpc-add-to-cart]');

      if (!(button instanceof HTMLButtonElement)) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (
        button.disabled ||
        button.classList.contains('is-loading')
      ) {
        return;
      }

      const variantId = String(button.dataset.variantId || '');
      if (!variantId) return;

      button.classList.remove('is-added');
      button.classList.add('is-loading');
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      setStatus(button, 'Adding to cart');

      try {
        const addedItem = await addWithAjax(variantId);
        const cart = await getCart();

        /*
         * Use a private event instead of Shopify's cart:update event.
         * The native Horizon drawer listens to cart:update and was opening
         * briefly before the custom SV drawer, creating the open/close glitch.
         */
        document.dispatchEvent(
          new CustomEvent(PRODUCT_CARD_ADDED_EVENT, {
            detail: {
              cart,
              item: addedItem,
              variantId,
              openCart: button.dataset.openCart === 'true',
            },
          })
        );

        button.classList.remove('is-loading');
        button.classList.add('is-added');
        setStatus(button, 'Added to cart');

        window.setTimeout(() => {
          button.classList.remove('is-added');
        }, 1600);
      } catch (error) {
        console.error(
          '[Fashion product card] Add to cart failed:',
          error
        );

        button.classList.remove('is-loading', 'is-added');
        setStatus(
          button,
          error?.message || 'Unable to add to cart'
        );
        button.title =
          error?.message || 'Unable to add to cart';
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
